import { render } from "./Content.vue?vue&type=template&id=fcabf786"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=fcabf786&lang=css"
script.render = render

export default script